export default __webpack_public_path__ + "static/media/Q15_1_resized.ff5183d0.jpg";